<template>
  <div class="modal-wrapper">
    <transition :name="transitionName" mode="out-in">
      <ModalViewerCategoryContentsItem
        :key="`${post.slug}`"
        :offset-top="offsetTop"
      />
    </transition>
  </div>
</template>
<script lang="ts" setup>
import { dataExportImportCommon } from '~/lib/data/exportImportCommon';

interface Props {
  offsetTop: number;
}
defineProps({
  offsetTop: null
});

const { $db } = useNuxtApp();

const profile = useProfileStore();

const { contentIndex, libraryBookId, post } = inject(INJECT_MODAL_CATEGORY);

const direction = ref<'left' | 'right'>('left');

const transitionName = computed(() => `slide-${direction.value}`);

const { exportCoachingStats } = dataExportImportCommon(
  $db,
  useApiFetch,
  profile.syncContext
);

useCoachingStatsTime(libraryBookId);

watch(
  () => contentIndex.value,
  (to, from) => (direction.value = to > from ? 'left' : 'right')
);

onBeforeMount(() => {
  exportCoachingStats();
});
</script>
<style lang="scss" scoped>
.modal-wrapper {
  z-index: 1;
  width: 100%;
  @include above('l') {
    min-height: auto;
    overflow: hidden;
  }
}
</style>
